import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';

const CATEGORIES = ['Exterior', 'Interior', 'Kitchen', 'Bathroom', 'Bedroom', 'Other'];

export default function PropertyPhotoUpload({ propertyId, onUploaded, onClose }) {
  const [files, setFiles] = useState([]);
  const [caption, setCaption] = useState('');
  const [category, setCategory] = useState('Other');
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    if (files.length === 0) return;
    setUploading(true);

    for (const file of files) {
      const path = `${propertyId}/${Date.now()}-${file.name}`;
      const { error } = await supabase.storage
        .from('property-photos')
        .upload(path, file);

      if (!error) {
        await supabase.from('property_photos').insert({
          property_id: propertyId,
          storage_path: path,
          filename: file.name,
          caption: caption.trim() || null,
          category,
        });
      }
    }

    setUploading(false);
    onUploaded();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Upload Photos</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Photos *</label>
            <label className="photo-upload-area">
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={e => setFiles(Array.from(e.target.files))}
                style={{ display: 'none' }}
              />
              <span>{files.length > 0 ? `${files.length} file(s) selected` : '+ Select Photos'}</span>
            </label>
            {files.length > 0 && (
              <div className="photo-thumbnails" style={{ marginTop: 8 }}>
                {files.map((file, i) => (
                  <div key={i} className="photo-thumb">
                    <img src={URL.createObjectURL(file)} alt={file.name} />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="form-group">
            <label>Caption</label>
            <input
              value={caption}
              onChange={e => setCaption(e.target.value)}
              placeholder="Optional caption..."
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <select value={category} onChange={e => setCategory(e.target.value)}>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleUpload} disabled={uploading || files.length === 0}>
            {uploading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </div>
    </div>
  );
}
